import { createStyles, Drawer, makeStyles, Theme, useMediaQuery, useTheme } from "@material-ui/core";
import { DRAWER_WIDTH } from "config/constants";
import React from "react";
import styled from "styled-components/macro";

import CloseIcon from "@material-ui/icons/Close";

export interface SliderProps {
  children?: React.ReactNode;
  openDrawer: boolean;
  handleClose?: () => void;
}

export const DrawerContent = styled("div")`
  flex: 1 1 auto;
  padding: ${(p) => p.theme.spacing(2)}px ${(p) => p.theme.spacing(2)}px;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
`;
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    drawer: {
      width: DRAWER_WIDTH,
      flexShrink: 0,
      whiteSpace: "nowrap",
      marginTop: 65,
      padding: 20,
      overflowX: "hidden",
      background: "#f5f6f8",
      display: "flex",
      justifyContent: "column",
      [theme.breakpoints.down("xs")]: {
        width: "100%",
      },
    },
    closeBtn: {
      marginRight: "auto",
      [theme.breakpoints.down("xs")]: {
        marginLeft: "92%",
      },
    },
  })
);

export function Slider({ children, openDrawer, handleClose = () => {} }: SliderProps) {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));
  const styles = useStyles();
  return (
    <>
      {isSmallScreen ? (
        <Drawer
          variant="temporary"
          classes={{
            paper: styles.drawer,
          }}
          open={openDrawer}
          anchor={theme.direction === "rtl" ? "left" : "right"}
          onClose={handleClose}
          ModalProps={{
            keepMounted: true,
          }}
        >
          <div className={styles.closeBtn} onClick={handleClose}>
            <CloseIcon
              style={{
                color: "#399ebf",
              }}
              fontSize="large"
            />
          </div>

          {children}
        </Drawer>
      ) : (
        children
      )}
    </>
  );
}
